import { render, staticRenderFns } from "./SavedRulesSelector.vue?vue&type=template&id=37f157d4"
import script from "./SavedRulesSelector.vue?vue&type=script&lang=js"
export * from "./SavedRulesSelector.vue?vue&type=script&lang=js"
import style0 from "./SavedRulesSelector.vue?vue&type=style&index=0&id=37f157d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports